<div *ngIf="importing">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>
<div *ngIf="!importing">
	<div class="grid flex text-center">
		<div class="col-12">{{'IMPORT_ADDING_WARNING' | translate }}</div>
		<div class="col-12">{{ 'IMPORT_OVERWRITE_WARNING' | translate }}</div>
	</div>
	<div class="grid mt-5 mb-1 gap-1 flex justify-content-center align-items-center">
		<p-button
			[label]="('IMPORT_ADDING' | translate)" (click)="submitAdding()"
			severity="primary"
			class=" mt-3 sm:mt-0"
			styleClass=" {{ dynamicButtonWidth()}} text-xl font-normal"
		>
		</p-button>
		<p-button
			[label]="('IMPORT_OVERWRITE' | translate)" (click)="submitOverwrite()"
			severity="danger"
			class=" mt-3 sm:mt-0"
			styleClass=" {{ dynamicButtonWidth()}} text-xl font-normal"
		>
		</p-button>
		<button type="button" pButton pRipple (click)="closeDialog()"
			label="{{ 'CANCEL' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0"
			[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>
<p-confirmDialog #overwriteConfDialog class="p-confirm-dialog-content">
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton
				[label]="overwriteConfDialog.acceptButtonLabel"
				[ngClass]="acceptButtonStyle"
				(click)="overwriteConfDialog.accept()">
			</button>
			<button type="button" pButton
				[label]="overwriteConfDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle"
				(click)="overwriteConfDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>